import withAuthControl from "src/containers/withAuthControl";

export const AuthRoute = ({ component, ...componentProps }) => {
  const Component = withAuthControl(component);
  return <Component {...componentProps} />;
};
